import { Button } from './Button';
import { Sheet } from './Sheet';

/**
 * The one confirmation for turning a dish off, shared by every screen that can do it (the kitchen now;
 * management adopts it in a later phase). Turning a dish back on needs no confirmation.
 */
export function ConfirmAvailability({
  itemName,
  pending = false,
  onConfirm,
  onClose,
}: {
  itemName: string;
  /** The request is on its way: the confirm button shows it and cannot be pressed twice. */
  pending?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Sheet open onClose={onClose} title={`Mark ${itemName} unavailable?`}>
      <p className="mb-2 text-base text-ink">
        Customers and waiters can&apos;t order it from now on, until you make it available again.
      </p>
      <p className="mb-4 text-sm text-muted">Orders already placed are not changed.</p>
      <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="destructive" loading={pending} onClick={onConfirm}>
          Mark unavailable
        </Button>
      </div>
    </Sheet>
  );
}
